import { render, staticRenderFns } from "./PagamentosEletronicosRHPagamentosEletronicosView.vue?vue&type=template&id=5e06ac82&scoped=true"
import script from "./PagamentosEletronicosRHPagamentosEletronicosView.vue?vue&type=script&setup=true&lang=js"
export * from "./PagamentosEletronicosRHPagamentosEletronicosView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PagamentosEletronicosRHPagamentosEletronicosView.vue?vue&type=style&index=0&id=5e06ac82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e06ac82",
  null
  
)

export default component.exports